import instance from "../../../helpers/AxiosInterceptor";

export const listCoeffAbattKm = () => {
    return instance.get(`/settings/coefkm/list`);
};

export const findCoeffAbattKm = (id) => {
    return instance.get(`/settings/coefkm/find/${id}`);
};

export const createCoeffAbattKm = (request) => {
    return instance.post(`/settings/coefkm/create`, JSON.stringify(request));
};

export const updateCoeffAbattKm = (request) => {
    return instance.put(`/settings/coefkm/update`, JSON.stringify(request));
};
